import { GraphQLResponseWithData } from 'relay-runtime';

import { MiddlewareType } from './types';
import { getSettingsResponse } from './util';

export const remoteSettingsMiddleware: MiddlewareType = async (args, next) => {
    const { operation } = args;

    if (operation.name === 'RemoteSettingsQuery' || operation.name === 'UpdateRemoteSettingMutation') {
        const existingSettingsStore = localStorage.getItem('settings');

        if (existingSettingsStore) {
            const settingsResponse = (await next(args)) as GraphQLResponseWithData;

            const settingsFromServer =
                operation.operationKind === 'query'
                    ? settingsResponse.data?.settings?.edges?.[0]?.node
                    : settingsResponse.data?.updateSetting;
            if (settingsFromServer) {
                const existingSettings = JSON.parse(existingSettingsStore);
                const serverSettingsData = JSON.parse(settingsFromServer.data ?? '{}');
                const existingSettingsData = JSON.parse(existingSettings.data ?? '{}');
                existingSettingsData.gantEditScheduleItem = serverSettingsData.gantEditScheduleItem;

                existingSettings.data = JSON.stringify(existingSettingsData);

                localStorage.setItem('settings', JSON.stringify(existingSettings));
                return getSettingsResponse(operation.operationKind, existingSettings);
            } else {
                const existingSettings = JSON.parse(existingSettingsStore);
                return getSettingsResponse(operation.operationKind, existingSettings);
            }
        }
    }

    return next(args);
};
